import styled from 'styled-components';

export const UserQwrapper = styled.div`
  background: #fff;
  padding: 0 20px;

  & .userquestion {
    & strong {
      padding: 1.1em 6px 0 0;
    }

    & h1 {
      font-size: 16px;
      font-weight: 600;
      color: hsl(0deg, 0%, 0%, 87%);
      padding-bottom: 16px;
    }

    @media (max-width: 720px) {
      padding: 20px 20px 5px;
    }
  }

  @media (max-width: 720px) {
    padding: 0;
  }

  .light {
    opacity: 0.6;
  }
`;

export const UserQuestionImageSec = styled.div`
  position: relative;
  padding-top: 45%;
  margin-bottom: 10px;

  @media (max-width: 720px) {
    padding-top: 56.5%;
  }

  img {
    width: ${(props) => (props.stage ? '50%' : '100%')};
    max-height: 200px;
    margin: 16px 0 16px;
    outline: 1px solid hsl(0deg, 0%, 0%, 10%);
    border-radius: 8px;
    object-fit: cover;
    position: absolute;
    top: 0;
    height: 100%;
    @media (max-width: 720px) {
      width: 100%;
    }
  }
`;

export const Follow = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #0000008c;
  visibility: hidden;
`;

export const QuestionRelatedTitle = styled.h5`
  color: #63b0a8;
  font-weight: 600;
  padding-bottom: 10px;
`;
export const QuestionTitle = styled.div`
  display: flex;
  justify-content: space-between;

  p {
    opacity: 0.4;
    font-size: 13px;
  }
`;

export const ParentingCommunityQ = styled.p`
  font-weight: 500 !important;
  color: hsl(0deg, 0%, 0%, 87%) !important;
  display: -webkit-box;
  -webkit-line-clamp: 10;
  -webkit-box-orient: vertical;
  overflow: hidden;
  padding-top: 6px;
`;

export const AnswerSection = styled.div`
  display: flex;
  align-items: center;

  img {
    width: 20px;
    height: 20px;
  }

  span {
    font-size: clamp(14px, 3vw, 16px);
  }

  @media (min-width: 720px) {
    img {
      width: 24px;
      height: 24px;
    }
  }
`;

export const ShareButton = styled.div`
  display: flex;
  align-items: center;
  position: relative;

  img {
    width: 20px;
    height: 20px;
  }

  span {
    font-size: clamp(14px, 3vw, 16px);
    margin-bottom: 5px;
  }

  button {
    position: absolute;
    right: 0;
    padding-right: 100% !important;
  }

  @media (min-width: 720px) {
    img {
      width: 24px;
      height: 24px;
    }
  }
`;

export const PregnancyWeekCustomText = styled.div`
  display: flex;
  font-size: 13px;
  justify-content: space-between;
  align-items: center;
  margin: 5px 0px 10px;
  height: 20px;

  .views {
    display: flex;
    align-items: center;
    column-gap: 4px;
  }

  .week {
  }

  img {
    height: 20px;
    opacity: 0.6;
    width: 20px;
  }
`;
